import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';

export var UnitTools = {
	
	insertV6EntityIdDetail: function(detail, data) {
		if (!detail || !data || !data.v6EntityId) {
			return detail;
		}
		var insertAt = 0;
		for (var index = 0; index < detail.length; index++) {
			var row = detail[index];
			if (row && !row.section && row.key && String(row.key).toLowerCase().indexOf(' id') !== -1) {
				insertAt = index + 1;
				break;
			}
		}
		detail.splice(insertAt, 0, {
			key: 'V6 Entity Id',
			value: data.v6EntityId
		});
		return detail;
	},

	displayDetails: function(options) {
	
		var detailWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Details',
			icon: 'vaadin:folder-open',				
			width: .75,
			height: .75,
			listeners: {
				ready: function() {						
					detailWin.show();	
					
					var detailTable = ElementUtil.create({
						tag: 'dl-detail-table',
						itemid: 'detailtable',
						slot: 'primary'
					});					
					
					var nextPrevToolbar = ElementUtil.create({
						tag: 'dl-nextprev-toolbar',
						slot: 'footer',
						listeners: {
							ready: function(event){
								event.target.updateData(options.allData);
								event.target.setSelectedRecord(options.selectField, options.record[options.selectField]);								
								detailTable.updateDetails(options.getDetails(options.record));							
							},
							change: function(event) {
								options.grid.deselectItem(options.record);
								options.grid.selectItem(event.detail.item);
								options.record = event.detail.item;
								detailTable.updateDetails(options.getDetails(options.record));									
							}										
						}
					});
					
					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [							
							detailTable,
							nextPrevToolbar
						]
					});	
					
					detailWin.addToContentElement(layout);					
					
				}
			}
		});
	},
	
	multipleReferences: function(options) {
		var refWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Reference',
			icon: 'vaadin:folder-open',				
			width: .75,
			height: .75,
			listeners: {
				ready: function() {						
					refWin.show();	
										
					var toolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [							
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',								
								children: [
									ElementUtil.makeIcon('vaadin:plus', ' Add')
								],
								listeners: {
									click: function () {
										actionAddEdit();
									}
								}
							},
							{
								tag: 'dl-action-button',
								itemid: 'edit',
								'class': 'spacer-toolbar-item',
								disabled: true,								
								children: [
									ElementUtil.makeIcon('vaadin:edit', ' Edit')
								],
								listeners: {
									click: function () {
										actionAddEdit(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'div',
								style: 'float: right;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'delete',
										theme: 'primary error',
										'class': 'spacer-toolbar-item',										
										children: [
											ElementUtil.makeIcon('vaadin:trash', 'Delete')
										],
										listeners: {
											click: function () {
												actionDelete(grid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});	
					
					var grid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'wrap-cell-content row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true,
							listeners: {
								'direction-changed': function (event) {
									if (event.detail && event.detail.value) {
										grid.currentSortField = event.target.path;
										grid.currentSortDirection = event.detail.value.toUpperCase();										
									}
								}
							}
						},
						children: [							
							{
								path: 'referenceTypeDescription',
								header: 'Unit Type',
								width: '7em'
							},
							{
								path: 'multiReferenceTypeDescription',
								header: 'Reference Type',
								width: '7em'
							},
							{
								path: 'referenceValue',
								header: 'Value',
								width: '7em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								grid.selectedItems = item ? [item] : [];
								if (grid.selectedItems.length > 0) {
									ElementUtil.query(toolbar, 'edit').disabled = false;
									ElementUtil.query(toolbar, 'delete').disabled = false;
								} else {
									ElementUtil.query(toolbar, 'edit').disabled = true;
									ElementUtil.query(toolbar, 'delete').disabled = true;
								}								
							}
						}
					});	
					
					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [	
							toolbar,
							grid
						]
					});	
					
					refWin.addToContentElement(layout);
				
					var actionRefresh = function() {
						options.loadRefs(grid);
					};
					actionRefresh();
					
					var actionAddEdit = function(record) {
						var addEditWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: (record ? 'Edit' : 'Add') + ' Reference',
							icon: 'vaadin:edit',				
							width: 450,
							height: 300,
							listeners: {
								ready: function() {						
									addEditWin.show();	
									
									var formPanel = ElementUtil.create({
										tag: 'dl-form-panel',
										itemid: 'form',
										children: [
											{
												tag: 'vaadin-form-layout',
												children: [													
													{
														tag: 'vaadin-combo-box',
														itemid: 'referenceTypeCB',
														label: 'Reference Type',
														name: 'multiReferenceType',
														'item-value-path': 'code',
														'item-label-path': 'description',
														required: true,
														postinit: function (combo) {
															Service.getLookupService().getLookupValues('MultiReferenceType').then(function (data) {
																combo.items = data;
															});
														}
													},
													{
														tag: 'vaadin-text-field',
														name: 'referenceValue',
														label: 'Reference Value',
														maxLength: 255
													},																										
													{
														tag: 'hr',
														colspan: 2
													},
													{
														tag: 'div',
														style: 'text-align: center;',
														colspan: 2,
														defaults: {
															tag: 'vaadin-button'
														},
														children: [
															{
																theme: 'primary',
																children: [
																	ElementUtil.makeIcon('vaadin:database', ' Save')
																],
																listeners: {
																	click: function () {

																		formPanel.submitForm({
																			preSubmit: function (data) {																				
																				return data;
																			},
																			actualCall: function (data) {
																				if (record) {
																					data.multiReferenceId = record.multiReferenceId;
																				}
																				return options.saveReference(data, (record ? true : false));
																			},
																			success: function (data, responseData) {
																				window.DL.MessageUtil.showToast('Success', 'Saved Reference', {
																					theme: 'success',
																					position: 'top-stretch'
																				});
																				actionRefresh();
																				addEditWin.close();
																			}
																		});
																		
																	}
																}
															},
															{
																theme: 'tertiary',
																innerHTML: 'Cancel',
																style: 'margin-left: 10px;',
																listeners: {
																	click: function () {
																		//cancel
																		addEditWin.close();
																	}
																}
															}
														]
													}
												]
											}
										]
									});
									
									addEditWin.addToContentElement(formPanel);
									
									if (record) {
										formPanel.load(record);
									}
								}
							}
						});						
					};
					
					var actionDelete = function(record) {
						window.DL.MessageUtil.showConfirm({
							title: 'Confirm Delete',
							message: '<b>Are you sure you want to delete "' + record.referenceValue + '"?</b>',
							buttons: [
								{
									text: 'Yes',
									handler: function() {
										var loadMask = grid.showLoading('Removing...');

										options.handleDelete(record.multiReferenceId, function(){
											loadMask.remove();
											window.DL.MessageUtil.showToast('Success', 'Removed ' + record.referenceValue, {
												theme: 'success'
											});
											actionRefresh();
										});				
									}
								},
								{
									text: 'No'
								}
							]
						});
						
					};
					
				}
			}
		});
	}
	
};

